import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect, useState } from 'react';
import GridLayout from '../../../components/modules/GridLayout';
import CartCheckoutHeader from '../CartCheckoutHeader';
import ErrorNotificationBanner from './ErrorNotificationBanner';
import InfoComponentsByDevice from './InfoComponentsByDevice';
import { NotificationBanner, NotificationTypes } from '@chegg-ui/notification-banner';
import { ADD_PAYMENT_METHOD, CANCEL_ANYTIME, FULL_PM_VIEW_CLASS, MULTI_MONTH_RESUB_LAYOUT_TESTID, PAYMENT_LEFT_CLASS, PLAN_SELECTION_LAYOUT_TESTID } from '../constants';
import { CtaContainer, MultiMonthWrapper, PaymentWrapper, ProductsWrapper, VariationsContainer, ValuePropsWrapper, LayoutWrapper } from '../styled';
import ProductDetails from './ProductDetails';
import { formatValueProps, getProductVariations, ProductType, ProductVariationRow, Size, SubscriptionInfo, ValueProps, VpnNotificationBanner } from '@chegg/commerce-utils';
import { useReactiveVar } from '@apollo/client';
import { reactiveAltProductData, reactiveCartData } from '../../../lib/ApolloSchema/reactiveVars';
import GridFooter from './GridFooter';
import DropInPaymentsLayout from './DropInPaymentsLayout';
import onError from '../../../utils/onError';
import { getUniqueIDLookUp } from '../../../utils/TransformUtils';
import getSelectProductVariationData from '../../../utils/getSelectProductVariationData';
import { getLayoutContent } from '../../../utils/getLayoutContent';
import { PaddingContainer } from '../../../components/common/styled';
import { getMonthlyBasePrice, getSavingsPercentage } from '../helpers';
export var PlanSelectionLayout = function PlanSelectionLayout(_ref) {
  var _getMonthlyBasePrice, _content$packages, _getMonthlyBasePrice2, _content$packages2, _tncProps$priceWithDi, _$saleBanner, _content$packages3, _content$packages4, _content$packages5;
  var authorization = _ref.authorization,
    calculatedPrice = _ref.calculatedPrice,
    content = _ref.content,
    ctaContent = _ref.ctaContent,
    displayServerErrors = _ref.displayServerErrors,
    isMobile = _ref.isMobile,
    isReviewStep = _ref.isReviewStep,
    isVpnDetected = _ref.isVpnDetected,
    reviewStepEnabled = _ref.reviewStepEnabled,
    selectProduct = _ref.selectProduct,
    selectedProduct = _ref.selectedProduct,
    tax = _ref.tax,
    tncProps = _ref.tncProps,
    uiData = _ref.uiData,
    itemData = _ref.itemData,
    taxInfo = _ref.taxInfo,
    environment = _ref.environment,
    optimizelyClient = _ref.optimizelyClient,
    referrer = _ref.referrer,
    userUuid = _ref.userUuid,
    useForter = _ref.useForter,
    withCoupon = _ref.withCoupon,
    dipCommands = _ref.dipCommands,
    action = _ref.action,
    country = _ref.country,
    externalId = _ref.externalId,
    isCTALoading = _ref.isCTALoading,
    eligibleForCSPUpgrade = _ref.eligibleForCSPUpgrade,
    products = _ref.products,
    isMultimonthResubscribe = _ref.isMultimonthResubscribe,
    hasNeedHelpButton = _ref.hasNeedHelpButton,
    priceWithoutDiscount = _ref.price,
    isRecurly = _ref.isRecurly,
    recurlyCart = _ref.recurlyCart;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPlanSelectionInitialized = _useState2[0],
    setIsPlanSelectionInitialized = _useState2[1];
  var layoutContent = getLayoutContent({
    content: content,
    selectedProduct: selectedProduct,
    isMultimonthResubscribe: isMultimonthResubscribe,
    products: products
  });
  var subscriptionInfo = layoutContent.subscriptionInfo,
    billingCycleHeadingText = layoutContent.billingCycleHeadingText,
    billingCycle = layoutContent.billingCycle,
    badgeSave = layoutContent.badgeSave,
    planDuration = layoutContent.planDuration,
    bestValueText = layoutContent.bestValueText,
    selectedProductContents = layoutContent.selectedProductContents,
    CSPValueProps = layoutContent.CSPValueProps,
    CSValueProps = layoutContent.CSValueProps,
    cspContents = layoutContent.cspContents,
    errorModal = layoutContent.errorModal,
    coupon = layoutContent.coupon,
    orderSummary = layoutContent.orderSummary,
    paymentMethodsHeadingText = layoutContent.paymentMethodsHeadingText,
    paymentForm = layoutContent.paymentForm,
    paymentErrorModal = layoutContent.paymentErrorModal,
    secondaryValueProps = layoutContent.valueProps;
  var hasError = (uiData === null || uiData === void 0 ? void 0 : uiData.errorMessage) && displayServerErrors;
  var _useReactiveVar = useReactiveVar(reactiveAltProductData),
    altItemData = _useReactiveVar.altItemData,
    altPrice = _useReactiveVar.altPrice,
    altTaxInfo = _useReactiveVar.altTaxInfo,
    altDiscountedPrice = _useReactiveVar.altDiscountedPrice,
    isAltDiscountedPriceFetched = _useReactiveVar.isAltDiscountedPriceFetched;
  var _useReactiveVar2 = useReactiveVar(reactiveCartData),
    discountedPrice = _useReactiveVar2.discountedPrice;
  var primaryData = {
    itemData: itemData,
    price: calculatedPrice,
    taxInfo: taxInfo,
    basePrice: (_getMonthlyBasePrice = getMonthlyBasePrice(products[0])) !== null && _getMonthlyBasePrice !== void 0 ? _getMonthlyBasePrice : priceWithoutDiscount,
    savingsPercentage: getSavingsPercentage(products[0]),
    isDiscounted: getSavingsPercentage(products[0]) > 0 || !!discountedPrice,
    isCouponApplied: !!discountedPrice,
    couponAppliedText: (_content$packages = content.packages) === null || _content$packages === void 0 || (_content$packages = _content$packages[0].coupon) === null || _content$packages === void 0 ? void 0 : _content$packages.successText
  };
  var altData = {
    itemData: altItemData,
    price: altDiscountedPrice !== null && altDiscountedPrice !== void 0 ? altDiscountedPrice : altPrice,
    taxInfo: altTaxInfo,
    basePrice: (_getMonthlyBasePrice2 = getMonthlyBasePrice(products[1])) !== null && _getMonthlyBasePrice2 !== void 0 ? _getMonthlyBasePrice2 : altPrice,
    savingsPercentage: getSavingsPercentage(products[1]),
    isDiscounted: getSavingsPercentage(products[1]) > 0 || !!altDiscountedPrice,
    isCouponApplied: !!altDiscountedPrice,
    couponAppliedText: (_content$packages2 = content.packages) === null || _content$packages2 === void 0 || (_content$packages2 = _content$packages2[1].coupon) === null || _content$packages2 === void 0 ? void 0 : _content$packages2.successText
  };
  /* istanbul ignore next */
  var cspData = itemData[0].productType === ProductType.CHEGG_STUDY ? altData : primaryData;
  /* istanbul ignore next */
  var csData = itemData[0].productType === ProductType.CHEGG_STUDY ? primaryData : altData;
  var basePrice = selectedProduct.productType === ProductType.CHEGG_STUDY ? csData.basePrice : cspData.basePrice;
  var isDiscounted = selectedProduct.productType === ProductType.CHEGG_STUDY ? csData.isDiscounted : cspData.isDiscounted;
  var savingsPercentage = Math.max(primaryData.savingsPercentage, altData.savingsPercentage);
  var price = (_tncProps$priceWithDi = tncProps.priceWithDiscount) !== null && _tncProps$priceWithDi !== void 0 ? _tncProps$priceWithDi : tncProps.price;
  var footerContent = /*#__PURE__*/React.createElement(GridFooter, {
    authorization: authorization,
    isMobile: isMobile,
    isReviewStep: isReviewStep,
    reviewStepEnabled: reviewStepEnabled,
    ctaContent: ctaContent,
    tax: tax,
    tncProps: tncProps,
    selectedPrice: price,
    termsAndConditions: tncProps.termsAndConditions,
    basePrice: basePrice,
    isDiscounted: isDiscounted
  });
  var showStickyCTAFooter = isMobile && !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) || !eligibleForCSPUpgrade && !isMultimonthResubscribe;
  var eligibleToShowVpnBanner = isVpnDetected && !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM);
  var _products = _slicedToArray(products, 1),
    cspProduct = _products[0];
  // istanbul ignore next
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var productVariationContent = {
    billingCycleLong: billingCycle,
    badgeSave: badgeSave,
    planDuration: planDuration,
    bestValueText: bestValueText
  };
  var variations = isMultimonthResubscribe ? getProductVariations(cspProduct, productVariationContent) : [];
  var uniqueIdLookup = getUniqueIDLookUp(paymentForm === null || paymentForm === void 0 ? void 0 : paymentForm.paymentFields);
  var _uniqueIdLookup$getHe = uniqueIdLookup.getHeadingTexts(),
    addPaymentMethodHeading = _uniqueIdLookup$getHe.addPaymentMethodHeading,
    editPaymentMethodHeading = _uniqueIdLookup$getHe.editPaymentMethodHeading,
    cancelAnytime = _uniqueIdLookup$getHe.cancelAnytime;

  /**
   * In order to fetch alt discounted price, we first init cart with alt product. Once the
   * discounted price is fetched, we initialize plan selection by replacing the item in the
   * cart with the primary item, thus fetching it's discounted price. Once this replace is
   * complete, the loading state will conclude and OneClick will load.
   */
  useEffect(function () {
    if (isAltDiscountedPriceFetched && !isPlanSelectionInitialized) {
      selectProduct({
        productType: ProductType.CHEGG_STUDY,
        itemData: itemData.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            replace: true
          });
        }),
        orderSummaryContent: content.orderSummary,
        taxInfo: taxInfo
      });
      setIsPlanSelectionInitialized(true);
    }
  }, [isAltDiscountedPriceFetched, isPlanSelectionInitialized]);
  return /*#__PURE__*/React.createElement(GridLayout, _extends({
    dataTest: PLAN_SELECTION_LAYOUT_TESTID
  }, showStickyCTAFooter && {
    footer: footerContent
  }, {
    showOnlyPm: uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM,
    hasNeedHelpButton: hasNeedHelpButton
  }), /*#__PURE__*/React.createElement(CartCheckoutHeader, {
    content: subscriptionInfo,
    showOnlyPM: uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM,
    cardActionMode: uiData === null || uiData === void 0 ? void 0 : uiData.cardActionMode,
    allowPlanSelection: true,
    addPaymentMethodHeading: addPaymentMethodHeading,
    editPaymentMethodHeading: editPaymentMethodHeading,
    selectedPrice: price,
    authorization: authorization,
    savingsPercentage: savingsPercentage,
    saleBannerHeaderContent: (_$saleBanner = content.packages[0].saleBanner) === null || _$saleBanner === void 0 ? void 0 : _$saleBanner.bannerTitle,
    saleBannerBadgeContent: content.packages[0].badgeUpToPercentOff,
    action: action,
    country: country
  }), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && hasError && /*#__PURE__*/React.createElement(ErrorNotificationBanner, {
    errorMessage: uiData.errorMessage
  }), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && !isMultimonthResubscribe && /*#__PURE__*/React.createElement(ProductsWrapper, null, /*#__PURE__*/React.createElement(ProductDetails, _extends({}, cspData, {
    content: formatValueProps(CSPValueProps),
    selectedProduct: selectedProduct,
    selectProduct: selectProduct,
    orderSummaryContent: cspContents === null || cspContents === void 0 ? void 0 : cspContents.orderSummary,
    isLoaded: !(uiData !== null && uiData !== void 0 && uiData.isCTADisabled)
  })), /*#__PURE__*/React.createElement(ProductDetails, _extends({}, csData, {
    content: formatValueProps(CSValueProps),
    selectedProduct: selectedProduct,
    selectProduct: selectProduct,
    orderSummaryContent: content.orderSummary,
    isLoaded: !(uiData !== null && uiData !== void 0 && uiData.isCTADisabled)
  }))), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && isMultimonthResubscribe && /*#__PURE__*/React.createElement(LayoutWrapper, {
    "data-test": MULTI_MONTH_RESUB_LAYOUT_TESTID
  }, /*#__PURE__*/React.createElement(MultiMonthWrapper, null, /*#__PURE__*/React.createElement("p", null, billingCycleHeadingText), /*#__PURE__*/React.createElement(VariationsContainer, null, variations.map(function (variation) {
    return /*#__PURE__*/React.createElement(ProductVariationRow, _extends({
      size: Size.COMPACT,
      isSelected: selectedProduct.id === variation.catalogItemId,
      key: variation.title,
      onClick: function onClick() {
        var selectProductVariationData = getSelectProductVariationData({
          variation: variation,
          cspProduct: cspProduct,
          orderSummary: orderSummary
        });
        selectProduct(selectProductVariationData);
      }
      // @TODO fetch from contentful
      ,
      subscriptionRecurrence: '/mo'
    }, variation));
  }))), /*#__PURE__*/React.createElement(ValuePropsWrapper, {
    isMobile: isMobile
  }, /*#__PURE__*/React.createElement(ValueProps, {
    content: formatValueProps(secondaryValueProps),
    onError: onError,
    hideIcon: true
  }))), (uiData === null || uiData === void 0 ? void 0 : uiData.newUserNoMop) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 10,
    bottom: 10
  }), /*#__PURE__*/React.createElement(SubscriptionInfo, {
    content: {
      header: addPaymentMethodHeading || ADD_PAYMENT_METHOD,
      subHeader: cancelAnytime || CANCEL_ANYTIME,
      billingCadence: subscriptionInfo.billingCadence
    },
    headingLevel: 2,
    price: price,
    authorization: authorization,
    onError: onError
  })), /*#__PURE__*/React.createElement(PaymentWrapper, {
    allowPlanSelection: true,
    eligibleForCSPUpgrade: eligibleForCSPUpgrade,
    isReviewStep: isReviewStep,
    onlyPM: uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM,
    isMultimonthResubscribe: isMultimonthResubscribe
  }, /*#__PURE__*/React.createElement("div", {
    className: uiData !== null && uiData !== void 0 && uiData.showOnlyPM ? FULL_PM_VIEW_CLASS : PAYMENT_LEFT_CLASS
  }, (uiData === null || uiData === void 0 ? void 0 : uiData.showInitializeError) && /*#__PURE__*/React.createElement(NotificationBanner, {
    id: 'initializeErrorBanner',
    title: (errorModal === null || errorModal === void 0 ? void 0 : errorModal.header) || /* istanbul ignore next */'',
    type: NotificationTypes.Error,
    message: (errorModal === null || errorModal === void 0 ? void 0 : errorModal.body) || /* istanbul ignore next */''
  }), (uiData === null || uiData === void 0 ? void 0 : uiData.showOnlyPM) && hasError && /*#__PURE__*/React.createElement(ErrorNotificationBanner, {
    errorMessage: uiData.errorMessage
  }), paymentMethodsHeadingText && /*#__PURE__*/React.createElement(DropInPaymentsLayout, {
    authorization: authorization,
    isReviewStep: isReviewStep,
    coupon: coupon,
    orderSummary: orderSummary,
    paymentForm: paymentForm,
    paymentErrorModal: paymentErrorModal,
    reviewStepEnabled: reviewStepEnabled,
    environment: environment,
    optimizelyClient: optimizelyClient,
    referrer: referrer,
    taxInfo: taxInfo,
    userUuid: userUuid,
    useForter: useForter,
    withCoupon: withCoupon,
    dipCommands: dipCommands,
    action: action,
    country: country,
    externalId: externalId,
    isCTALoading: isCTALoading,
    venmoVisible: true,
    googlepayVisible: true,
    recurlyCart: recurlyCart,
    isRecurly: isRecurly
  })), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && !isMobile && (eligibleForCSPUpgrade || isMultimonthResubscribe) && /*#__PURE__*/React.createElement(CtaContainer, null, ctaContent)), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && !eligibleForCSPUpgrade && !isMultimonthResubscribe && secondaryValueProps && /*#__PURE__*/React.createElement(ValueProps, {
    content: formatValueProps(secondaryValueProps),
    onError: onError
  }), isMobile && eligibleToShowVpnBanner && /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 30,
    bottom: 10
  }, /*#__PURE__*/React.createElement(VpnNotificationBanner, {
    bannerTitle: (_content$packages3 = content.packages) === null || _content$packages3 === void 0 || (_content$packages3 = _content$packages3[0]) === null || _content$packages3 === void 0 || (_content$packages3 = _content$packages3.notificationBanner) === null || _content$packages3 === void 0 ? void 0 : _content$packages3.bannerTitle,
    link: (_content$packages4 = content.packages) === null || _content$packages4 === void 0 || (_content$packages4 = _content$packages4[0]) === null || _content$packages4 === void 0 || (_content$packages4 = _content$packages4.notificationBanner) === null || _content$packages4 === void 0 ? void 0 : _content$packages4.link,
    linkText: (_content$packages5 = content.packages) === null || _content$packages5 === void 0 || (_content$packages5 = _content$packages5[0]) === null || _content$packages5 === void 0 || (_content$packages5 = _content$packages5.notificationBanner) === null || _content$packages5 === void 0 ? void 0 : _content$packages5.linkText,
    isMobile: isMobile,
    allowPlanSelection: true
  })), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && isMultimonthResubscribe && isMobile && /*#__PURE__*/React.createElement(ValuePropsWrapper, null, /*#__PURE__*/React.createElement(ValueProps, {
    content: formatValueProps(secondaryValueProps),
    onError: onError,
    hideIcon: true
  })), !(uiData !== null && uiData !== void 0 && uiData.showOnlyPM) && /*#__PURE__*/React.createElement(InfoComponentsByDevice, {
    authorization: authorization,
    content: !isMultimonthResubscribe ? selectedProductContents : content,
    ctaContent: ctaContent,
    allowPlanSelection: true,
    eligibleForCSPUpgrade: eligibleForCSPUpgrade,
    isMobile: isMobile,
    isReviewStep: isReviewStep,
    price: price,
    basePrice: basePrice,
    reviewStepEnabled: reviewStepEnabled,
    tax: tax,
    tncProps: tncProps,
    isMultimonthResubscribe: isMultimonthResubscribe,
    eligibleToShowVpnBanner: eligibleToShowVpnBanner,
    isDiscounted: isDiscounted
  }));
};
export default PlanSelectionLayout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/PlanSelectionLayout.js
// module id = 4708
// module chunks = 11